const LANGUAGE_LABELS = {
    de: 'Deutsch',
    en: 'English'
};

// The shop login sitepart always renders the same ids, so the forms of further panes get their own
// ones to keep the labels pointing to the inputs of their own form.
function makeIdsUnique(form, index) {
    form.id = form.id + '_' + index;
    for (const element of form.querySelectorAll('[id]')) {
        const label = form.querySelector('label[for="' + element.id + '"]');
        element.id = element.id + '_' + index;
        if (label) {
            label.htmlFor = element.id;
        }
    }
}

function buildTabs(panes, activeIndex, showPane) {
    const tabs = document.createElement('div');
    tabs.className = 'loginTabs';
    const list = document.createElement('ul');
    list.className = 'loginTabs__list';
    tabs.append(list);

    panes.forEach((pane, index) => {
        const languageCode = pane.dataset.language;
        const tab = document.createElement('li');
        if (index === activeIndex) {
            tab.classList.add('is-active');
        }

        // same flags as the language switch (default/templates/siteparts/languageSwitch.mustache)
        const flag = document.createElement('img');
        flag.src = '/userdata/images/flags/' + languageCode + '.svg';
        flag.alt = '';
        flag.width = 20;
        flag.height = 20;
        tab.append(flag, LANGUAGE_LABELS[languageCode] || languageCode.toUpperCase());

        tab.addEventListener('click', () => showPane(index));
        list.append(tab);
    });

    return tabs;
}

/**
 * The catalog's login modal holds one pane per shop language (CMS layout areas "header_login_modal"
 * and "header_login_modal_en"). With more than one, each pane gets a tab bar above its login form
 * and the tabs switch between the panes. CMS links to "#login-<language>" (e.g. "#login-de") switch
 * as well (#238597).
 */
export function initCatalogLoginTabs() {
    const modal = document.getElementById('login_buy_modal');
    const panes = modal ? [...modal.querySelectorAll('.loginModalPane')] : [];
    if (panes.length < 2) {
        return;
    }

    const showPane = activeIndex => {
        panes.forEach((pane, index) => {
            pane.hidden = index !== activeIndex;
        });
    };

    modal.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#login-"]');
        if (!link) {
            return;
        }
        const index = panes.findIndex(pane => link.getAttribute('href') === '#login-' + pane.dataset.language);
        if (index < 0) {
            return;
        }
        event.preventDefault();
        showPane(index);
        // the link sits further down, so show the switched pane from its start
        modal.scrollTop = 0;
        modal.querySelector('.modal__dialog').scrollTop = 0;
    });

    panes.forEach((pane, index) => {
        const form = pane.querySelector(':scope > form.loginForm');
        pane.insertBefore(buildTabs(panes, index, showPane), form || pane.firstChild);

        if (index > 0) {
            for (const paneForm of pane.querySelectorAll('form.loginForm')) {
                makeIdsUnique(paneForm, index);
            }
        }
    });

    showPane(0);
}
